var url = "8d5b248f33b43bc0e070cd02f75e3c8b.jpg";
var cdnUrl = typeof _wml !== "undefined" && _wml.cdn && _wml.cdn.map(url);
module.exports = cdnUrl || __webpack_public_path__ + url;